import FontFaceObserver from 'fontfaceobserver';
import P from 'bluebird';
import log from '../services/logger_service';

if (!window.Promise) {
  window.Promise = P;
}

const fonts = ['FCIcon2015', 'FCKaiser', 'FCZizouSans', 'MeretPro'];
export default class FontLoaderUtil {
  static loadFonts() {
    const fontPromise = P.all(
      fonts.map(function observeFont(fontname) {
        return new FontFaceObserver(fontname);
      })
    );
    return fontPromise
      .then(function fontLoadSuccess() {
        document.documentElement.className +=
          document.documentElement.className === ''
            ? 'fonts-loaded'
            : ' fonts-loaded';
      })
      .catch(function fontLoadFail(err) {
        document.documentElement.className +=
          document.documentElement.className === ''
            ? 'fonts-loaded fonts-loaded-error'
            : ' fonts-loaded fonts-loaded-error';
        log.error(err, 'Error in font loader loading fonts.');
      });
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/font_loader_util.js